import { Injectable } from '@angular/core';
//import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { AngularFirestore } from 'angularfire2/firestore';
import { UsersService } from '../../models/usuarios.service';
//import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class MessagingService {

  messaging = firebase.messaging()
  currentMessage = new BehaviorSubject(null)

  constructor(private db: AngularFirestore, private afAuth: AngularFireAuth,
    private user: UsersService) {

    navigator.serviceWorker.register('/assets/firebase-messaging-sw.js')
      .then(registration => {
        this.messaging.useServiceWorker(registration);
      });

  }

  updateToken(token) {
    this.afAuth.authState.take(1).subscribe(user => {
      if (!user) return;
      const data = { data: new Date(), source: 'web', uid: user.uid, email: user.email, room: "admin", token: token }
      this.db.collection('nc-pushRegister/web/web').doc(user.uid).set(data, { merge: true });
      this.db.collection('nc-pushRegister/web/web').doc(user.email).set(data, { merge: true });
    })
  }

  getPermission() {
    this.messaging.requestPermission()
      .then(() => {
        console.log('Notification permission granted.');
        let rt = this.messaging.getToken();
        //console.log(rt);
        return rt;
      })
      .then(token => {
        //console.log(token)
        this.updateToken(token)
      })
      .catch((err) => {
        console.log('Unable to get permission to notify.', err);
      });
  }

  receiveMessage() {
    this.messaging.onMessage((payload:any) => {
      this.currentMessage.next(payload)
    });

  }


  // Listen for token refresh
  monitorRefresh() {
    this.messaging.onTokenRefresh(() => {
      this.messaging.getToken()
        .then(refreshedToken => {
          console.log('Token refreshed.');
          this.updateToken(refreshedToken)
        })
        .catch(err => console.log(err, 'Unable to retrieve new token'))
    });
  }

}